import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcHelpdeskH32(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "33",
    height: "32",
    fill: "none",
    viewBox: "0 0 33 32",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.313 14c0-5.937 4.812-10.75 10.75-10.75S26.813 8.063 26.813 14v6.5a8.25 8.25 0 0 1-8.25 8.25h-1.21a.75.75 0 0 1 0-1.5h1.21a6.75 6.75 0 0 0 6.75-6.75V14a9.25 9.25 0 0 0-18.5 0v3.22a.75.75 0 0 1-1.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.313 16.666a2.75 2.75 0 0 1 2.75-2.75h2.083a2.75 2.75 0 0 1 2.75 2.75v4.457a2.75 2.75 0 0 1-2.75 2.75H8.062a2.75 2.75 0 0 1-2.75-2.75zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v4.457c0 .69.56 1.25 1.25 1.25h2.083c.69 0 1.25-.56 1.25-1.25v-4.457c0-.69-.56-1.25-1.25-1.25zM19.23 16.666a2.75 2.75 0 0 1 2.75-2.75h2.083a2.75 2.75 0 0 1 2.75 2.75v4.457a2.75 2.75 0 0 1-2.75 2.75h-2.084a2.75 2.75 0 0 1-2.75-2.75zm2.75-1.25c-.691 0-1.25.56-1.25 1.25v4.457c0 .69.559 1.25 1.25 1.25h2.083c.69 0 1.25-.56 1.25-1.25v-4.457c0-.69-.56-1.25-1.25-1.25z",
    clipRule: "evenodd"
  }));
}
var IcHelpdeskH32 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHelpdeskH32));

export { IcHelpdeskH32 as I };
